module.exports = __webpack_public_path__ + "079acd1d82fbca580f71de2d8b807eed.pdf";